import React from 'react';
import { Card } from 'antd';

export default function ProfilePage() {
  return (
    <Card title="Profile">
      <p>Информация о пользователе</p>
    </Card>
  );
}